module.exports = __webpack_public_path__ + "assets/31dee88755d58817285faa5238acf61d.png";